import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import ShowIpgTransactionResult from './ShowIpgTransactionResult';


export default function ZarinpalVerifyPayment(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [verifying, setVerifying] = useState(true);
    const [transactionResult, setTransactionResult] = useState({});
    const [searchParams] = useSearchParams();
    const Authority = searchParams.get("Authority");

    useEffect(() => {
        
        setVerifying(true);
        var params = {
            authority:Authority 
        };
        var url = config.Server+`/payment/zarinpal/verify`;
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                setTransactionResult(response.data);
            }
            else{
                setTransactionResult(response.data);
            }
            setVerifying(false);
        })
        .catch(err => {
            var result = {
                hasError:true,
                transactionDate:0,
                transactionTime:0,
                contractNo:0,
                amount:0,
                continueLink:"",
                messages:[err.message],
                walletTransactionType:{id:0, title:""},
                traceNo:"",
            };
            setTransactionResult(result);
            setVerifying(false);
        });
    }, [Authority]);
    
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (verifying === true)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال بررسی تراکنش پرداخت..." />
                </Col>
            </Row>
        </>
        :
        <>
            <ShowIpgTransactionResult result={transactionResult} />
        </>
    )
}